import { schema, Schema } from './groups-form.schema';
import { zodResolver } from '@hookform/resolvers/zod';
import { Button } from '~/components/Button/Button';
import { useParams } from '~/hooks/useParams';
import { Grid } from '~/components/Grid/Grid';
import { Input } from '~/components/Input';
import { useForm } from 'react-hook-form';
import { idParamSchema } from '~/schemas';

interface Props {
  onSubmit: (data: Schema) => void;
  mode: 'create' | 'edit';
  defaultValues?: Schema;
  isLoading: boolean;
  competitionStartDate?: string;
}

export function GroupsForm({ defaultValues, mode, isLoading, onSubmit, competitionStartDate }: Props) {
  const { id } = useParams(idParamSchema.parse);

  const { formState, register, handleSubmit } = useForm({
    defaultValues: defaultValues ?? { competition: id },
    resolver: zodResolver(schema),
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
      <Grid>
        <Grid.Item cols={{ sm: 12, md: 6 }}>
          <Input.Group formState={formState} htmlFor="name" label="Namn">
            <Input.Field type="text" {...register('name')} />
          </Input.Group>
        </Grid.Item>

        <Grid.Item cols={{ sm: 12, md: 6 }}>
          <Input.Group formState={formState} htmlFor="start" label="Startdatum">
            <Input.Field
              type="date"
              {...register('start')}
              defaultValue={competitionStartDate}
              min={competitionStartDate}
            />
          </Input.Group>
        </Grid.Item>
      </Grid>

      <Button.Group align="right">
        <Button type="submit" isLoading={isLoading}>
          {{ create: 'Skapa', edit: 'Spara' }[mode]}
        </Button>
      </Button.Group>
    </form>
  );
}
